import { useContext, useEffect, useState } from "react";
import useGlobalContext from "../context/useGlobalContext";
import { GlobalContext } from "../context/GlobalContext";
import { Box } from "@mui/system";
import ClientAsk7G from "../components/ClientOverview/ClientAsk7G";
import TaskNotifications from "../components/ActionItems/TaskNotifications";
import AppNotification from "../components/Common/AppNotification";
import ContactIcon from "../assets/contacts/contacts-primary-icon.svg";
import { useNotificationCount } from "../hooks/useNotificationCount";
import { Typography } from "@mui/material";
import Contacts from "../components/Contacts/Contacts";
import RightArrowIcon from "../assets/common/right-arrow-icon.svg";
import { useLocation } from "react-router-dom";
import "../styles/interactions.css";

const ContactsPage = () => {
  const { accountDetails } = useContext(GlobalContext);
  const { featureMap } = useGlobalContext();
  const location = useLocation();
  const isNotificationsEnabled = featureMap?.in_app_notifications === true;
  const userProfileOrgId = accountDetails?.profileOrgId ?? "";
  const userNotification = useNotificationCount(userProfileOrgId, isNotificationsEnabled);
  const Ask7GEnabled = featureMap?.business_ask7g === true;
  const [isAsk7GExpanded, setIsAsk7GExpanded] = useState(false);

  useEffect(() => {
    setIsAsk7GExpanded(false);
  }, [location.pathname, location.search]);

  return (
    <Box
      id="meetingsParent"
      className="flex flex-col justify-start items-start gap-6 m-2"
      style={{ width: "auto" }}
    >
      <div className="interaction-breadcrumbs flex flex-row items-center w-full mt-2">
        <div className="flex flex-row justify-start items-center gap-2">
          <Box
            component={isAsk7GExpanded ? "button" : "div"}
            type={isAsk7GExpanded ? "button" : undefined}
            className={`flex flex-row justify-start items-center gap-2 ask7g-home-breadcrumb ${
              isAsk7GExpanded ? "ask7g-home-breadcrumb--expanded" : "ask7g-home-breadcrumb--collapsed"
            }`}
            onClick={isAsk7GExpanded ? () => setIsAsk7GExpanded(false) : undefined}
          >
            <img
              src={ContactIcon}
              alt=""
              className={`breadCrumbs-text ${isAsk7GExpanded ? "breadCrumbs-text--expanded" : ""}`}
            />
            <Typography
              className={`breadCrumbs-text ${isAsk7GExpanded ? "breadCrumbs-text--expanded" : "breadCrumbs-text--collapsed"}`}
              sx={{ fontSize: "16px" }}
            >
              Contacts
            </Typography>
          </Box>
          {Ask7GEnabled && isAsk7GExpanded && (
            <>
              <img src={RightArrowIcon} alt="" style={{ marginTop: "3px" }} />
              <Typography className="breadCrumbs-text ask7g-current-breadcrumb" sx={{ fontSize: "16px" }}>
                Ask 7G
              </Typography>
            </>
          )}
        </div>
        <div className="ml-auto flex flex-row items-center gap-3">
          {isNotificationsEnabled && (
            <AppNotification
              notificationCount={userNotification.notificationCount}
              notificationApiRefetch={userNotification.getNotificationCountRefetch}
              contentComponent={<TaskNotifications userNotification={userNotification} />}
            />
          )}
          {Ask7GEnabled && (
            <ClientAsk7G
              view="icon"
              isExpanded={isAsk7GExpanded}
              onToggleExpand={setIsAsk7GExpanded}
            />
          )}
        </div>
      </div>
      {Ask7GEnabled && (
        <Box sx={{ width: "100%", display: isAsk7GExpanded ? "block" : "none" }}>
          <ClientAsk7G
            view="full"
            isExpanded={isAsk7GExpanded}
            onToggleExpand={setIsAsk7GExpanded}
          />
        </Box>
      )}
      <Box sx={{ display: isAsk7GExpanded ? "none" : "block", width: "100%" }}>
        <Contacts />
      </Box>
    </Box>
  );
};

export default ContactsPage;

